
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        infinite: true,
        autoplaySpeed: 2500,
        dots: true,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        rows: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
      options: [
        {
          name: 'logo',
          label: 'Image',
          type: 'image',
          size: '400x400',
        },
      ],
    }
  },
  methods: {
    scrollUnder() {
      const element = document.getElementById('box')
      let y = element.scrollHeight
      document.body.scrollTop = y + 128
      document.documentElement.scrollTop = y + 128
    },
  },
}
